<template>
  <v-container fluid class="box-container ma-0 pa-0">
    <!-- <v-row class="ma-0 pa-0 mt-2" align="center" justify="center">
    </v-row>
    <v-row class="ma-0 mx-2 mb-2 pa-0 " align="center" justify="center">
      
    </v-row>-->
    <div ref="refHelpMainContainer" class="row-content ma-0 pa-0">
      <v-expansion-panels inset ref="refExpansionPanels" v-model="expandedItems">
        <v-expansion-panel @click="stopVideo" v-for="(i, index) in items" :key="index" :ref="'refPanel' + index">
          <div v-if="i.name != 'help'">
            <v-expansion-panel-header>
              <div class="ma-0 pa-0" style="display: flex; width: 100%; align-items: center">
                <v-avatar size="40" class="flex-grow-0" :class="isOnMobile ? '' : 'mx-1'">
                  <v-icon :color="Colors.IconColor">{{ i.meta.icon }}</v-icon>
                </v-avatar>
                <span class="flex-grow-1" style="white-space: pre-wrap; line-height: 1.6">{{ (i.meta.group && i.meta.group != i.title ? i.meta.group + (isOnMobile ? "\n↪ " : " ↪ ") : "") + i.title }}</span>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-divider></v-divider>
              <v-row class="ma-0 pa-0" justify="center" align="start">
                <v-col class="ma-0 pa-0" align="start" align-self="start">
                  <v-card-actions v-for="(line, idx) in i.meta.description.split('\n')" :key="idx" class="row-content" :class="line.indexOf('•') > -1 ? 'ma-0 pa-0 pl-3' : ''" style="overflow: hidden">
                    <ul v-if="line.indexOf('•') > -1">
                      <li class="subtitle-1 text-custom">{{ line.substring(2) }}</li>
                    </ul>
                    <span v-else class="subtitle-1 text-custom">{{ line }}</span>
                  </v-card-actions>
                </v-col>
                <v-col v-if="i.meta.video_file">
                  <v-row class="ma-0 pa-0" style="height: 100%" align="center" justify="center">
                    <video :ref="'refPlayer' + index" :style="!isOnLandscape && isOnMobile ? 'border: 1; max-height: auto; max-width: 210px;' : 'border: 1; max-height: 400px; max-width: 500px;'" controls>
                      <source :src="i.meta.video_file" type="video/mp4" />
                    </video>
                  </v-row>
                </v-col>
                <v-col v-else-if="i.meta.video_url">
                  <v-row class="ma-0 pa-0" style="height: 100%" align="center" justify="center">
                    <video :ref="'refPlayer' + index" :style="!isOnLandscape && isOnMobile ? 'border: 1; width: 100%; max-height: auto; max-width: 210px;' : 'border: 1; width: 100%; max-height: 400px; max-width: 500px;'" controls>
                      <source :src="i.meta.video_url" type="video/mp4" />
                    </video>
                  </v-row>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </div>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
  </v-container>
</template>

<script>
import DataManager from "../../js/DataManager";
import bus, { TR } from "../../main";
// import Button from "../Controls/Button.vue";

export default {
  // components: { Button },
  data() {
    return {
      user: null,
      items: [],
      expandedItems: [],
      intervalMove: null,
    };
  },
  methods: {
    stopVideo() {
      if (this.expandedItems && this.$refs["refPlayer" + this.expandedItems]) this.$refs["refPlayer" + this.expandedItems][0].pause();
    },
    focusPanel(index) {
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.expandedItems != -1 && (this.expandedItems == index || (this.expandedItems instanceof Array && this.expandedItems.indexOf(index) != -1))) {
            var newVal = this.$refs["refPanel" + index][0].$el.offsetTop + this.$refs.refExpansionPanels.$el.offsetTop - 20;
            this.$refs.refHelpMainContainer.scrollTo(0, newVal);
            this.$nextTick(() => {
              if (this.$refs["refPlayer" + index]) {
                this.$refs["refPlayer" + index][0].play();
              }
            });
            // this.intervalMove = null;
            // var lastY = this.$refs.refHelpMainContainer.scrollTop;
            // if (this.$refs.refHelpMainContainer.scrollTop > this.$refs["refPanel" + index][0].$el.offsetTop + this.$refs.refExpansionPanels.$el.offsetTop - 20) {
            //   this.intervalMove = setInterval(() => {
            //     lastY = this.$refs.refHelpMainContainer.scrollTop;
            //     this.$refs.refHelpMainContainer.scrollTop -= 5;
            //     if (this.$refs.refHelpMainContainer.scrollTop <= this.$refs["refPanel" + index][0].$el.offsetTop + this.$refs.refExpansionPanels.$el.offsetTop - 20 || this.$refs.refHelpMainContainer.scrollTop == lastY) {
            //       clearInterval(this.intervalMove);
            //     }
            //   }, 5);
            // } else if (this.$refs.refHelpMainContainer.scrollTop < this.$refs["refPanel" + index][0].$el.offsetTop + this.$refs.refExpansionPanels.$el.offsetTop - 20) {
            //   this.intervalMove = setInterval(() => {
            //     lastY = this.$refs.refHelpMainContainer.scrollTop;
            //     this.$refs.refHelpMainContainer.scrollTop += 5;
            //     this.$nextTick(() => {
            //       if (this.$refs.refHelpMainContainer.scrollTop >= this.$refs["refPanel" + index][0].$el.offsetTop + this.$refs.refExpansionPanels.$el.offsetTop - 20 || this.$refs.refHelpMainContainer.scrollTop == lastY) {
            //         clearInterval(this.intervalMove);
            //       }
            //     });
            //   }, 5);
            // }
          }
        }, 500);
      });
    },
  },
  mounted() {
    this.user = DataManager.getData(DataManager.DataType.user);
    this.items = this.$router.options.routes.filter((f) => f.name == "MainContent")[0].children.filter((f) => f.meta && f.path.startsWith("/" + TR.Locale + "/") && (f.meta.video_url || f.meta.description) && DataManager.userHasAccess(f.meta.for_user));
    bus.$on(bus.EVENT_Help_Needed, (nm) => {
      var index = this.items.findIndex((i) => i.name == nm);
      this.expandedItems = index;
      this.focusPanel(index);
    });
  },
};
</script>

<style>
</style>
